const getBaseUrl = () => {
	const env = process.env.NEXT_PUBLIC_VERCEL_ENV ?? '';

	switch (env) {
		case 'development':
			return 'http://localhost:3001';
		case 'staging':
			return 'https://qa-data.supra.com';
		case 'production':
			return 'https://data.supra.com';
		default:
			return `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`;
	}
};

export default getBaseUrl;
